<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="550px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Add locale</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                        v-model="edited.targetLanguageId"
                        :disabled="saving"
                        :items="choices"
                        :rules="[required]"
                        item-text="name"
                        item-value="id"
                        label="Language"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import differenceWith from 'lodash/differenceWith'
import { TRANSLATION_DICTIONARY_CREATE } from '../store/action-types'

const COMMON_ERROR = 'Error has occurred while saving'

export default {
  props: ['value', 'sourceDictionary'],
  data () {
    return {
      valid: false,
      saving: false,
      errorOnSave: COMMON_ERROR,
      showErrorOnSave: false,
      edited: {}
    }
  },
  computed: {
    ...mapState([
      'languages'
    ]),
    choices () {
      const sourceLanguage = this.sourceDictionary.language ? this.sourceDictionary.language.id : null
      return differenceWith(this.languages, this.sourceDictionary.translationDictionaries, (language, translationDictionary) => {
        return language.id === translationDictionary.targetLanguage.id
      }).filter(language => language.id !== sourceLanguage)
    }
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      this.edited = this.defaultModel()
    }
  },
  methods: {
    defaultModel () {
      return {
        sourceLanguageId: this.sourceDictionary.language.id,
        targetLanguageId: null
      }
    },
    validate () {
      this.errorOnSave = COMMON_ERROR
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        await this.$store.dispatch(TRANSLATION_DICTIONARY_CREATE, this.edited)
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
